import { InfoCircleTwoTone, TwoToneColor } from "@ant-design/icons";
import { ReactNode } from "react";
import { Button } from "antd";
import { useAppDispatch } from "@Components/CustomerApp/hooks";
import { showChatBanner } from "@Components/CustomerApp/customerAppSlice";
import { CustomerChatMessageEnum } from "../CustomerChatBanner";

const InfoBaseBannerMessage = ({
    children,
}: {
    children: ReactNode;
}): JSX.Element => {
    const twoToneColor: TwoToneColor = ["#cce5f0", "#1890ff"];

    const dispatch = useAppDispatch();

    return (
        <>
            <div className="chat-banner_top">
                <InfoCircleTwoTone
                    twoToneColor={twoToneColor}
                    className="chat-banner_top_icon"
                    data-testid="customer-chat-banner-icon"
                />
                <div
                    className="chat-banner_top_message"
                    data-testid="customer-chat-banner-message"
                >
                    {children}
                </div>
            </div>
            <Button
                type="link"
                className="chat-banner_dismiss_button"
                data-testid="customer-chat-banner-dismiss-button"
                onClick={(): void => {
                    // Set isDismissed to true and clear the banner message
                    dispatch(
                        showChatBanner({
                            isDismissed: true,
                            chatBannerMessage: CustomerChatMessageEnum.NONE,
                            active: false,
                        })
                    );
                }}
            >
                <p>Dismiss</p>
            </Button>
        </>
    );
};

export default InfoBaseBannerMessage;
